export default "__VITE_ASSET__19a310c5__"